module.exports = __webpack_public_path__ + "img/d70c148.jpg";